<div id="container">
  <ae-content-load *ngIf="isLoading"></ae-content-load>
  <router-outlet></router-outlet>
</div>
